import React from 'react';
import styles from './Modal.module.css';

/**
 * ModalBody Component
 *
 * Body section for Modal component
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Body content
 * @param {string} props.className - Additional CSS classes
 */
const ModalBody = ({ children, className = '' }) => {
  const bodyClasses = [styles.body, className].filter(Boolean).join(' ');

  return <div className={bodyClasses}>{children}</div>;
};

export default ModalBody;
